module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overflow-x-auto mx-4 mb-5",
    attrs: {
      "id": "skills-summary"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "w-full flex justify-center items-center h-96"
  }, [_c('pl-spinner')], 1) : _c('div', [(_vm.skills && _vm.skills.length !== 0) ? _c('div', [_c('table', {
    staticClass: "table-auto min-w-full"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left px-2 py-2 border-b bg-white text-blueGray-800 select-none"
  }, [_vm._v("Skill")]), _vm._v(" "), _vm._l((_vm.skills), function(data, index) {
    return _c('th', {
      key: index,
      staticClass: "text-center px-3 py-2 border-b cursor-pointer hover:underline bg-white"
    }, [_c('Popper', {
      attrs: {
        "append-to-body": true,
        "prevent-default": true,
        "trigger": "hover",
        "options": {
          placement: 'top',
        }
      },
      on: {
        "show": _vm.openPopper,
        "hide": _vm.closePopper
      }
    }, [_c('div', {
      staticClass: "popper bg-white rounded-md shadow-sm relative"
    }, [_c('div', {
      staticClass: "flex items-center space-x-2 px-3 py-2"
    }, [_c('div', {
      staticClass: "h-5 w-5 bg-blue rounded-full flex items-center justify-center"
    }, [_c('img', {
      staticClass: "w-2.5 h-2.5",
      attrs: {
        "src": "/static/roundtable_icons/written_icon.svg"
      }
    })]), _vm._v(" "), _c('h6', {
      staticClass: "text-blueGray-800 text-xs font-poppins"
    }, [_vm._v(_vm._s(data.roundtable))])])]), _vm._v(" "), _c('button', {
      staticClass: "h-full items-center font-semibold hover:underline font-poppins text-blueGray-800",
      attrs: {
        "slot": "reference"
      },
      on: {
        "click": function($event) {
          return _vm.handleGoRT(data.roundtable_id)
        }
      },
      slot: "reference"
    }, [_vm._v("\n                  RT " + _vm._s(index + 1) + "\n                ")])])], 1)
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.skillsName), function(dataName, rowIndex) {
    return _c('tr', {
      key: rowIndex
    }, [_c('td', {
      staticClass: "border-b py-1.5 px-2 font-poppins font-light"
    }, [_c('Popper', {
      attrs: {
        "append-to-body": true,
        "prevent-default": true,
        "trigger": "clickToToggle",
        "options": {
          placement: 'right',
          modifiers: {
            offset: {
              offset: '0,8px'
            }
          }
        }
      },
      on: {
        "show": function($event) {
          return _vm.openPopper(dataName)
        },
        "hide": _vm.closePopper
      }
    }, [_c('div', {
      directives: [{
        name: "click-outside",
        rawName: "v-click-outside",
        value: (_vm.closePopper),
        expression: "closePopper"
      }],
      staticClass: "popper bg-white rounded-md shadow-sm relative w-64 pb-4"
    }, [_c('div', {
      staticClass: "py-2.5 font-semibold text-sm font-poppins text-left w-full px-3"
    }, [_vm._v("\n                    " + _vm._s(dataName) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "text-left text-xs flex flex-col px-3 text-gray-700 font-poppins font-light"
    }, [_c('div', {
      staticClass: "html-content font-poppins font-light",
      domProps: {
        "innerHTML": _vm._s(_vm.handleSetAssessmentDescription(dataName))
      }
    })]), _vm._v(" "), (_vm.selected_points_description && _vm.selected_points_description.length > 0) ? _c('div', {
      staticClass: "mt-4 px-3"
    }, _vm._l((_vm.selected_points_description), function(point) {
      return _c('div', {
        staticClass: "flex flex-col text-left text-xs space-y-2"
      }, [_c('div', {
        staticClass: "flex items-center space-x-1 mb-2"
      }, [_c('div', {}, [_c('span', {
        staticClass: "font-semibold font-poppins text-gray-800"
      }, [_vm._v("(" + _vm._s(point.value) + ") Level: ")]), _c('span', {
        staticClass: "text-gray-700"
      }, [_vm._v(_vm._s(point.description))])])])])
    }), 0) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "h-full items-center font-semibold hover:underline font-poppins mr-2 text-blueGray-800",
      attrs: {
        "slot": "reference",
        "type": "button"
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "fa-solid fa-circle-info"
    })])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(dataName))])], 1), _vm._v(" "), _vm._l((_vm.skills), function(data, index) {
      return _c('td', {
        key: index,
        staticClass: "text-left px-3 py-2 border-b bg-white"
      }, [_vm._l((data.assessments), function(skill, index) {
        return _c('div', {
          key: index
        }, [_c('div', {
          staticClass: "flex justify-center items-center"
        }, [(skill.title === dataName) ? _c('div', {
          staticClass: "w-8 h-8 flex items-center text-white justify-center select-none text-base font-poppins font-semibold rounded",
          class: {
            'bg-blueDark bg-opacity-10': parseInt(skill.value) === 0,
            'bg-blueDark bg-opacity-20': parseInt(skill.value) === 1,
            'bg-blueDark bg-opacity-40': parseInt(skill.value) === 2,
            'bg-blueDark bg-opacity-60': parseInt(skill.value) === 3,
            'bg-blueDark bg-opacity-80': parseInt(skill.value) === 4,
            'bg-blueDark ': parseInt(skill.value) > 4,
          }
        }, [_c('span', [_vm._v(_vm._s(skill.value))])]) : _vm._e()])])
      }), _vm._v(" "), (!data.stats.skills.some(function (item) { return item.title === dataName; })) ? _c('div', {
        staticClass: "flex justify-center items-center"
      }, [_vm._m(0, true)]) : _vm._e()], 2)
    })], 2)
  }), 0)])]) : _c('div', {
    staticClass: "w-full flex justify-center items-center h-96"
  }, [_c('span', {
    staticClass: "font-poppins text-blueGray-800"
  }, [_vm._v("No data to display")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-8 h-8 flex items-center text-white justify-center text-base select-none font-poppins font-semibold rounded bg-gray-200"
  }, [_c('span', {
    staticClass: "text-blueGray-500"
  }, [_vm._v("-")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3e19abce!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/pages/Reports/WrittenCharts/SkillsSummary.vue
// module id = 2277
// module chunks = 61